<template>
  <default-dialog v-model="dialog" title="Reordenar">
    <orderer :originalArray="originalArray" @arrayReordered="arrayReordered">
      <template v-slot:default="slotProps">
        <content-tile :content="slotProps.item" :index="slotProps.index" />
      </template>
    </orderer>
    <template slot="rightButton">
      <v-btn @click="didTapSaveReorder" text>Salvar</v-btn>
    </template>
  </default-dialog>
</template>

<script>
import { updateContentOrder } from "@/firebase/api/content";
import Orderer from "@/components/Orderer";
import ContentTile from "@/components/contents/Tile";
import DefaultDialog from "@/components/dialogs/Default";

export default {
  components: { DefaultDialog, ContentTile, Orderer },
  props: {
    value: Boolean,
    originalArray: Array
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  methods: {
    arrayReordered(newArray) {
      this.reorderedContents = newArray.map(value => value.id);
    },
    didTapSaveReorder() {
      this.dialog = false;
      updateContentOrder(this.$route.params.chapterID, this.reorderedContents);
    }
  }
};
</script>